import { render } from "./DataSummarySection.vue?vue&type=template&id=222e5023&scoped=true&ts=true"
import script from "./DataSummarySection.vue?vue&type=script&lang=ts"
export * from "./DataSummarySection.vue?vue&type=script&lang=ts"

import "./DataSummarySection.vue?vue&type=style&index=0&id=222e5023&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222e5023"]])

export default __exports__